import PropTypes from "prop-types"
import React from "react"

const { createContext, useState } = React
const FeedbackDrawerContext = createContext(null)

function FeedbackDrawerContextProvider(props) {
  const [isFeedbackDrawerOpen, setIsFeedbackDrawerOpen] = useState(false)

  return (
    <FeedbackDrawerContext.Provider
      value={{ isFeedbackDrawerOpen, setIsFeedbackDrawerOpen }}
    >
      {props.children}
    </FeedbackDrawerContext.Provider>
  )
}

FeedbackDrawerContextProvider.propTypes = {
  children: PropTypes.node
}

export default FeedbackDrawerContext
export { FeedbackDrawerContextProvider }
